import { UUID } from 'v2/core/entities/uuid';
import { NormalisedNode } from 'v2/querybuilder/types/querystore';

interface ErrorNode {
  filterID: UUID;
  message: string;
}

export const getErrorNode = (
  nodes: Record<string, NormalisedNode>,
  currentNodeID: UUID,
  filters: Set<string> = new Set(),
): ErrorNode | null => {
  const currentNode = nodes[currentNodeID];

  if (currentNode.type === 'filter' && currentNode.field === 'category') {
    if (filters.has(currentNode.field)) {
      return {
        filterID: currentNode.id,
        message:
          "Hold your horses! You can't filter 'Category' twice in the same group for now.",
      };
    }

    filters.add(currentNode.field);
  }

  if (currentNode.type === 'group') {
    const newCategories = new Set<string>();
    for (const childID of currentNode.children) {
      const errorNode = getErrorNode(nodes, childID, newCategories);
      if (errorNode) {
        return errorNode;
      }
    }
  }

  return null;
};
